import { Paper } from '@mui/material';

import { TabsManager } from 'uiKit/TabsManager';
import { useTabs } from 'modules/common/hooks/useTabs';

import { useAAPIInfoTabs } from './hooks/useAAPIInfoTabs';
import { useAAPIInfoTabsStyles } from './useAAPIInfoTabsStyles';

export const AAPIInfoTabs = () => {
  const tabs = useAAPIInfoTabs();

  const [sections, section] = useTabs({
    tabs,
  });

  const { classes } = useAAPIInfoTabsStyles();

  return (
    <Paper className={classes.advancedApiInfoTabsPaper}>
      <TabsManager
        className={classes.advancedApiInfoTabs}
        classNameTabsInner={classes.advancedApiInfoTabsInner}
        selectedTab={section}
        tabs={sections}
      />
    </Paper>
  );
};
